import LandingPageShell from "@/components/landing-page/layout/LandingPageShell";
import CatalogCardsClient from "@/components/catalog/CatalogCardsClient";
import { DEFAULT_CATALOG_MODULE_COUNTS } from "@/lib/data/catalog-module-counts";
import CatalogHeroClient from "@/components/catalog/CatalogHeroClient";
import FindYourPath from "@/components/catalog/FindYourPath";

export default function CatalogPage() {
  return (
    <LandingPageShell>
      <CatalogHeroClient />
      <CatalogCardsClient moduleCounts={DEFAULT_CATALOG_MODULE_COUNTS} />
      <FindYourPath />
    </LandingPageShell>
  );
}
